<div class="embed-container">
  <div class="embed-error" *ngIf="errorMessage">
    <p>{{ errorMessage }}</p>
  </div>

  <ng-container *ngIf="!errorMessage">
    <div class="embed-frame-wrap">
      <mat-spinner *ngIf="isLoading" class="embed-spinner" [diameter]="50"></mat-spinner>

      <div class="embed-timeout-message" *ngIf="timedOut">
        <p>{{ labels.timedOutMessage }}</p>
      </div>

      <iframe
        *ngIf="sanitizedUrl"
        [src]="sanitizedUrl"
        (load)="onIframeLoad()"
        class="embed-frame"
        title="Therapy Referrals"
        referrerpolicy="strict-origin-when-cross-origin"
        sandbox="allow-scripts allow-same-origin allow-forms allow-downloads"
        allow="clipboard-write"
      ></iframe>
    </div>
  </ng-container>
</div>
